
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired1df"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired1df"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("3sKfs", function(module, exports) {
module.exports = new URL("service-worker.js", import.meta.url).toString();

});

var $c3fe36e6e5e8885b$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["jRPZQ","index.159ae2f2.js","iCPtY","service-worker.js"]'));

// app.js
// Регистрация Service Worker

if ("serviceWorker" in navigator) window.addEventListener("load", ()=>{
    navigator.serviceWorker.register((parcelRequire("3sKfs"))).then((registration)=>{
        console.log("ServiceWorker \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0441 \u043E\u0431\u043B\u0430\u0441\u0442\u044C\u044E:", registration.scope);
    }).catch((error)=>{
        console.log("\u041E\u0448\u0438\u0431\u043A\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 ServiceWorker:", error);
    });
});
// Обработка кнопок
document.addEventListener("DOMContentLoaded", ()=>{
    const gateBtn = document.getElementById("gateBtn");
    const barrier1Btn = document.getElementById("barrier1Btn");
    const barrier2Btn = document.getElementById("barrier2Btn");
    // URL-адреса для запросов (замените на ваши реальные конечные точки)
    const gatePhone = "+79186893480";
    const barrier1Phone = "+79186893482";
    const barrier2Phone = "+79186893484";
    const url = "https://gates-pwa.vipcrm.ru/api/gate/";
    const token = "c8f83b32d51284dbedb745d178c1270a";
    // Функция для отправки запроса
    // Функция для отправки запроса
    const sendRequest = (url, phone)=>{
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "callto": phone,
                "token": token
            })
        }).then((response)=>{
            const statusMessage = document.getElementById("statusMessage");
            if (response.ok) {
                statusMessage.textContent = "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E!";
                statusMessage.style.color = "green"; // Успешное сообщение
            } else {
                statusMessage.textContent = "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B.";
                statusMessage.style.color = "red"; // Ошибка
            }
        }).catch((error)=>{
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430:", error);
            const statusMessage = document.getElementById("statusMessage");
            statusMessage.textContent = "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430.";
            statusMessage.style.color = "red"; // Ошибка
        });
    };
    // Обработчики событий для кнопок
    gateBtn.addEventListener("click", ()=>{
        sendRequest(url, gatePhone);
    });
    barrier1Btn.addEventListener("click", ()=>{
        sendRequest(url, barrier1Phone);
    });
    barrier2Btn.addEventListener("click", ()=>{
        sendRequest(url, barrier2Phone);
    });
});


//# sourceMappingURL=index.159ae2f2.js.map
